import { EnumEnvironment } from '@libs/constants';

import { ENVIRONMENT } from '../../../../environments';


// The build environment selects the source; local testing never changes the production URL.
export const UPDATE_ANNOUNCEMENT_FEED_URL: string = ENVIRONMENT.ENVIRONMENT === EnumEnvironment.Production
	? 'https://flying-research.s3.eu-central-1.amazonaws.com/updates/updates.json'
	: '/assets/update-feed/updates.json';
